// src/api/storeEndpoints.ts

import { API_V2 } from './apiVersion';

export const STORE_ENDPOINTS = {
  LIST:
    `${API_V2}/stores`,

  DETAIL: (
    storeId: number,
  ) =>
    `${API_V2}/stores/${storeId}`,

  SUPERADMIN: {
    CREATE:
      `${API_V2}/superadmin/stores`,

    DETAIL: (
      storeId: number,
    ) =>
      `${API_V2}/superadmin/stores/${storeId}`,
  },

  ADMIN: {
    MINT_POINTS: (
      storeId: number,
    ) =>
      `${API_V2}/admin/stores/${storeId}/points/mint`,

    RESET_SCORES: (
      storeId: number,
    ) =>
      `${API_V2}/admin/stores/${storeId}/scores/reset`,
  },
} as const;